import PageContainer from '@/common/components/PageContainer'
import useQueryGetDomains from '@/modules/admin/api/hooks/useQueryGetDomains'
import DomainList from '@/modules/admin/components/DomainList'

export default function ManageDomainsPage() {
	const { data, isLoading } = useQueryGetDomains()

	const domains = data?.domains || []
	const clientDomain = data?.clientDomain || ''

	return (
		<PageContainer>
			<DomainList
				domains={domains}
				clientDomain={clientDomain}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}
